// Liked articles tab for the Activity page.
// Defers fetching until the user activates this tab (enabled: isActive) to avoid
// over-fetching data the user may never view; matches lazy-load pattern in BookmarksContext.tsx. (ref: DL-003)
import { useQuery, getActivityLikes } from "wasp/client/operations";
import ArticleCard from "../../articles/components/ArticleCard";
import { ArticleTabSkeleton } from "./ArticleTabSkeleton";
import { EmptyTabState } from "./EmptyTabState";
import { ErrorTabState } from "./ErrorTabState";
import { ARTICLE_CARD_GRID_CLASS } from "./articleGridClass";

interface LikesTabProps {
  isActive: boolean;
}

export function LikesTab({ isActive }: LikesTabProps) {
  const { data, isLoading, error, refetch } = useQuery(
    getActivityLikes,
    undefined,
    { enabled: isActive },
  );

  if (isLoading) {
    return <ArticleTabSkeleton />;
  }

  if (error) {
    return <ErrorTabState onRetry={() => refetch()} />;
  }

  if (!data || data.length === 0) {
    return (
      <EmptyTabState
        message="Heart the stories that inspire you and they will appear here."
        actionLabel="Browse articles"
        actionTo="/articles"
      />
    );
  }

  return (
    <div className={ARTICLE_CARD_GRID_CLASS}>
      {data.map(({ article }) => (
        <div key={article.id}>
          <ArticleCard article={article} />
        </div>
      ))}
    </div>
  );
}
